/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Button } from '@mui/material';
import DialogContainer from '../../../../../../../../components/shared/Dialog/DialogContainer';
import OrgAppAuthProviderCreation from './OrgAppAuthProviderCreation';

const OrgAppAuthProviderCreationBtn = () => {
    const [openCreationModal, setOpenCreationModal] = useState(false);
    const handleCloseDialog = () => {
        setOpenCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{ background: (theme) => theme.palette.gradiant.main, float: 'right' }}
                onClick={() => setOpenCreationModal(true)} >Register Application Identity Provider</Button>
            <DialogContainer
                open={openCreationModal}
                handleClose={handleCloseDialog}
            >
                <OrgAppAuthProviderCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default OrgAppAuthProviderCreationBtn;